import LocalizedStrings from "react-localization";
import en from "./en";
import React, { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

const cleanTranslation = (translations) => {
  const newTranslation = {};
  for (const [k, translation] of Object.entries(translations)) {
    if (translation) {
      newTranslation[k] = translation;
    }
  }
  return newTranslation;
};

const localStrings = new LocalizedStrings(
  {
    en: cleanTranslation(en),
  },
  { logsEnabled: false }
);

const Text = ({ text }) => {
  return text;
};

const Populate = ({ text = "", items, className }) => {
  const translated = useMemo(() => {
    const sentence = text.toString().split(" ");
    const buildSentence = [];
    sentence.forEach((word) => {
      let placeholder = false;
      items.forEach((item, key) => {
        const ph = `{${key}}`;
        if (word.toString().includes(ph)) {
          const startEnd = word.toString().split(ph);
          const start = startEnd?.[0] || "";
          const end = startEnd?.[1] || "";
          buildSentence.push(
            <>
              {start}
              {item}
              {end}{" "}
            </>
          );
          placeholder = true;
        }
      });
      if (!placeholder) {
        buildSentence.push(` ${word} `);
      }
    });
    return buildSentence;
  }, [text, items]);

  return (
    <span className={className}>
      {translated.map((t) => {
        return <Text key={uuidv4()} text={t} />;
      })}
    </span>
  );
};

const translation = (translations) => {
  const populate = (word, words) => {
    if (words.length) {
      words.forEach((text, key) => {
        word = word.replace(`{${key}}`, text);
      });
    }
    return word;
  };

  return { ...translations, populate, Populate };
};

export default translation(localStrings);
